module.exports = __webpack_public_path__ + "static/media/step1-kor.78809c7b.png";